import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export const GET_PAYMENT_OPTIONS = gql`
  query getPaymentOptions {
    paymentOptions {
      code
      description
    }
  }
`;

export const usePaymentOptionsOfflineData = () => {
  useQuery(GET_PAYMENT_OPTIONS, {
    fetchPolicy: 'cache-and-network',
  });
};
